import { forwardRef, ForwardedRef } from "react";
import { GroupBase, SelectInstance } from "react-select";

import { VirtualOption } from "./types";
import {
  VirtualMultiSelect,
  VirtualMultiSelectProps,
} from "./VirtualMultiSelect";

// Форвардим VirtualMultiSelect
export const ForwardedVirtualMultiSelect = forwardRef(
  <T, isMulti extends boolean = false>(
    props: VirtualMultiSelectProps<T, isMulti>,
    ref: ForwardedRef<
      SelectInstance<VirtualOption<T>, isMulti, GroupBase<VirtualOption<T>>>
    >,
  ) => {
    // Передаем пропсы и ref в оригинальный компонент
    return <VirtualMultiSelect<T, isMulti> {...props} forwardedRef={ref} />;
  },
);

// Добавляем displayName для лучшей отладки
ForwardedVirtualMultiSelect.displayName = "ForwardedVirtualMultiSelect";
